import {LitElement, html, css, svg} from 'lit';
import {customElement, property} from 'lit/decorators.js';

@customElement('obi-sound-low')
export class ObiSoundLow extends LitElement {
  @property({type: Boolean}) useCssColor = false;

  private icon = svg`<svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M11.2686 19.2689L8 16.0002H5.2C4.07989 16.0002 3.51984 16.0002 3.09202 15.7822C2.71569 15.5905 2.40973 15.2845 2.21799 14.9082C2 14.4804 2 13.9203 2 12.8002V11.2002C2 10.0801 2 9.52006 2.21799 9.09224C2.40973 8.71592 2.71569 8.40995 3.09202 8.21821C3.51984 8.00022 4.0799 8.00022 5.2 8.00022H8L11.2686 4.73159C12.1254 3.87484 12.5538 3.44646 12.9215 3.41752C13.2407 3.3924 13.5525 3.52158 13.7604 3.76499C14 4.04551 14 4.65133 14 5.86296V18.1375C14 19.3491 14 19.9549 13.7604 20.2355C13.5525 20.4789 13.2407 20.608 12.9215 20.5829C12.5538 20.554 12.1254 20.1256 11.2686 19.2689ZM8.82843 10.0002L12 6.82865V17.1718L8.82843 14.0002H4V10.0002H8.82843Z" fill="currentColor"/>
<path d="M16 9.76484V7.41833C16.5725 7.66821 17.0934 8.02327 17.5355 8.46538C17.9998 8.92967 18.3681 9.48087 18.6194 10.0875C18.8707 10.6941 19 11.3443 19 12.0009C19 12.6575 18.8707 13.3077 18.6194 13.9143C18.3681 14.521 17.9998 15.0722 17.5355 15.5364C17.0934 15.9786 16.5725 16.3336 16 16.5835V14.237C16.3344 13.9379 16.5995 13.5644 16.7716 13.149C16.9224 12.785 17 12.3949 17 12.0009C17 11.6069 16.9224 11.2168 16.7716 10.8529C16.5995 10.4374 16.3344 10.0639 16 9.76484Z" fill="currentColor"/>
</svg>
`;

  private iconCss = svg`<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M11.2686 19.2689L8 16.0002H5.2C4.07989 16.0002 3.51984 16.0002 3.09202 15.7822C2.71569 15.5905 2.40973 15.2845 2.21799 14.9082C2 14.4804 2 13.9203 2 12.8002V11.2002C2 10.0801 2 9.52006 2.21799 9.09224C2.40973 8.71592 2.71569 8.40995 3.09202 8.21821C3.51984 8.00022 4.0799 8.00022 5.2 8.00022H8L11.2686 4.73159C12.1254 3.87484 12.5538 3.44646 12.9215 3.41752C13.2407 3.3924 13.5525 3.52158 13.7604 3.76499C14 4.04551 14 4.65133 14 5.86296V18.1375C14 19.3491 14 19.9549 13.7604 20.2355C13.5525 20.4789 13.2407 20.608 12.9215 20.5829C12.5538 20.554 12.1254 20.1256 11.2686 19.2689ZM8.82843 10.0002L12 6.82865V17.1718L8.82843 14.0002H4V10.0002H8.82843Z" style="fill: var(--element-active-color)"/>
<path d="M16 9.76484V7.41833C16.5725 7.66821 17.0934 8.02327 17.5355 8.46538C17.9998 8.92967 18.3681 9.48087 18.6194 10.0875C18.8707 10.6941 19 11.3443 19 12.0009C19 12.6575 18.8707 13.3077 18.6194 13.9143C18.3681 14.521 17.9998 15.0722 17.5355 15.5364C17.0934 15.9786 16.5725 16.3336 16 16.5835V14.237C16.3344 13.9379 16.5995 13.5644 16.7716 13.149C16.9224 12.785 17 12.3949 17 12.0009C17 11.6069 16.9224 11.2168 16.7716 10.8529C16.5995 10.4374 16.3344 10.0639 16 9.76484Z" style="fill: var(--element-active-color)"/>
</svg>
`;

  override render() {
    return html`
      <div class="wrapper">${this.useCssColor ? this.iconCss : this.icon}</div>
    `;
  }

  static override styles = css`
    .wrapper {
      height: 100%;
      width: 100%;
      line-height: 0;
    }
    .wrapper > * {
      height: 100%;
      width: 100%;
    }
  `;
}

declare global {
  interface HTMLElementTagNameMap {
    'obi-sound-low': ObiSoundLow;
  }
}
